import { useContext, useRoute } from '@nuxtjs/composition-api';
import { installCategoryContext } from '~/modules/category/state/useCategoryState';
export function useWebSocket() {
  /**
   * WebSocket
   */
  const { $socket } = useContext();
  const route = useRoute();
  const routeName = route.value.name?.split('___')[0]; // i18n prefix remove

  const testCategoryIdMap = {
    '/test': 'livingPagesTest',
    '/test/anket': 'livingPagesTestAnket',
    '/test/astroloji-testleri': 'livingPagesTestAstroloji',
    '/test/genel-kultur-testleri': 'livingPagesTestGenelKultur',
    '/test/iliski-testleri': 'livingPagesTestIliski',
    '/test/kisilik-testleri': 'livingPagesTestKisilik',
    '/test/psikoloji-testleri': 'livingPagesTestPsikoloji',
    '/test/yemek-testleri': 'livingPagesTestYemek',
  };

  // prevent dublicate init calls at currency and live counts
  const shouldInit = () => {
    const wsExcludeList = ['index', '/test'];
    const status = wsExcludeList.some((path) => path === routeName || routeName?.startsWith(path));
    return !status;
  };

  installCategoryContext();

  return {
    Init: async ({ forceInit, cidChangeCallback }) => {
      if (forceInit || shouldInit()) {
        await $socket.Init({ cidChangeCallback });
      }
    },
    Subscribe: ({ topicIds, callback }) => {
      $socket.Subscribe({ topicIds, callback });
    },
    Unsubscribe: ({ topicIds, callback }) => {
      $socket.Unsubscribe({ topicIds, callback });
    },
    BindMeta: () => {
      $socket.BindMeta();
    },
    GetTopicIds: async (id) => {
      if (!id) {
        id = testCategoryIdMap[routeName];
      }
      return [(await $socket.GetTopicIds())[id]?.name];
    },
    GetClientId: async () => {
      return await $socket.GetClientId();
    },
    isOpen: async () => {
      return (await $socket.GetSocketState()) === 'OPEN';
    },
  };
}
